// import Axios from "axios";
// import { basicCatch } from "./api-helpers";

import Axios from "axios";
import { basicCatch } from "./api-helpers";

const state = {};

export const getters = {};

export const actions = {
  // ROUTES
  // GET
  getApiUsage(context) {
    return new Promise((res, rej) => {
      Axios.get(
        "/api-usage/" + context.rootState.session.currentUser.organization_id
      )
        .then(({ data }) => {
          const body = data.data;
          res(body);
        })
        .catch((err) => {
          basicCatch(err, "Error while trying to get API usage.");
          rej();
        });
    });
  },
};

export const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
